import { getAxios } from './apiUtils';

export const getSeries = async siteId => {
  return getAxios()
    .get(`/api/series/site/${siteId}`)
    .then(({ data }) => data);
};
export const addSeries = async series => {
  return getAxios()
    .post(`/api/series/site/${series.siteId}`, series)
    .then(({ data }) => data);
};
export const getPostsForSeries = async ({ siteId, seriesId }) => {
  return getAxios()
    .get(`/api/series/site/${siteId}/section/${seriesId}/posts`)
    .then(({ data }) => data);
};
export const updateSeries = async ({ siteId, series }) => {
  return getAxios()
    .put(`/api/series/site/${siteId}`, series)
    .then(({ data }) => data);
};
export const addPostToSeries = async ({ siteId, seriesId, postId }) => {
  return getAxios()
    .put(`/api/series/site/${siteId}/section/${seriesId}/post/${postId}`)
    .then(({ data }) => data);
};

export const removePostFromSeries = async ({ siteId, seriesId, postId }) => {
  return getAxios()
    .delete(`/api/series/site/${siteId}/section/${seriesId}/post/${postId}`)
    .then(({ data }) => data);
};
